import { render, staticRenderFns } from "./updateAvatarConfirmation.vue?vue&type=template&id=75d5c207"
import script from "./updateAvatarConfirmation.vue?vue&type=script&lang=js"
export * from "./updateAvatarConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports